import { useEffect } from "react";
import { useStateContext } from "contexts/ContextProvider";

export const usePageTitle = (title) => {
  const { setCustomPageTitle } = useStateContext();
  
  useEffect(() => {
    document.title = `${title} - CE Portal`;
    setCustomPageTitle((prev) => (prev === title ? prev : title));

    // Cleanup: reset to default when component unmounts
    return () => {
      document.title = "CE Portal";
      setCustomPageTitle((prev) => (prev === null ? prev : null));
    };
  }, [title, setCustomPageTitle]);
};
